import moment from 'moment';

export const isEmpty = (v) => [undefined, null, ''].includes(v);

// 获取归档线, 16号前归档线是上月1号，过了16号归档线是本月1号
export const getAchivedDate = () => {
  const today = moment();
  if (today.format('D') < 16) {
    return today
      .subtract(1, 'month')
      .set('date', 1)
      .startOf('day');
  }
  return today.set('date', 1).startOf('day');
};
